import * as React from 'react';
import InputText from '../../../../../common/components/InputText';
import Button from '../../../../../common/components/Button';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import * as OrientationTypes from '../../../../../common/components/OrientationTypes';
import Options from '../../../../../common/components/Options';
import DatePicker from '../../../../../common/components/DatePicker';
import {WorkDataStepViewProps, WorkDataStepViewState} from '../../../../types/mx/creditoReal/components';
import {CR_DEPENDENT_CATALOG_ID} from '../../../../constants/MotorcreditConstants';

class WorkDataStepView extends React.Component<WorkDataStepViewProps, WorkDataStepViewState> {
    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
        this.props.getLoanApplication();
        setTimeout(() => this.props.getAllQuotationInsurances(), 1000);
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onPressNext = () => {
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    checkIfPressNext = () => {
        if (this.props.workDataFieldsHasError) {
            return this.props.onPressNext();
        }
    }

    render() {

        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION_MX.WORK_INFO}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_COMPANY_NAME}
                                    id={INPUTS.EMPLOYMENT_COMPANY_NAME}
                                    value={this.props.workplaceNameField.value}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.workplaceNameField.error}
                                    onChange={this.props.onChangeWorkplaceName}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_POSITION}
                                    id={INPUTS.EMPLOYMENT_POSITION}
                                    value={this.props.positionField.value}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.positionField.error}
                                    onChange={this.props.onChangePosition}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <DatePicker
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_START_DATE}
                                    id={INPUTS.EMPLOYMENT_START_DATE}
                                    value={this.props.workingSinceField.value}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.workingSinceField.error}
                                    onChange={this.props.onChangeWorkingSince}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_ADDRESS}
                                    id={INPUTS.EMPLOYMENT_ADDRESS}
                                    value={this.props.addressField.value}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.addressField.error}
                                    onChange={this.props.onChangeAddress}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_EXTERNAL_NUMBER}
                                    id={INPUTS.EMPLOYMENT_EXTERNAL_NUMBER}
                                    value={this.props.extNumberField.value}
                                    required={true}
                                    maxLength={20}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.extNumberField.error}
                                    onChange={this.props.onChangeExtNumber}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_INTERNAL_NUMBER}
                                    id={INPUTS.EMPLOYMENT_INTERNAL_NUMBER}
                                    value={this.props.intNumberField.value}
                                    maxLength={20}
                                    onChange={this.props.onChangeIntNumber}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_POSTAL_CODE}
                                    id={INPUTS.EMPLOYMENT_POSTAL_CODE}
                                    value={this.props.postalCodeField.value}
                                    required={true}
                                    type={InputTextTypes.NUMBER}
                                    acceptLeadingZeros={true}
                                    maxLength={5}
                                    minLength={5}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.postalCodeField.error}
                                    onChange={this.props.onChangePostalCode}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_STATE}
                                    id={INPUTS.EMPLOYMENT_STATE}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.stateField.error}
                                    value={this.props.stateField.value}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_CITY}
                                    id={INPUTS.EMPLOYMENT_CITY}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.cityField.error}
                                    value={this.props.cityField.value}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_MUNICIPALITY}
                                    id={INPUTS.EMPLOYMENT_MUNICIPALITY}
                                    required={true}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.municipalityField.error}
                                    value={this.props.municipalityField.value}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_COLONY}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_COLONY}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.colonyField.value}
                                    data={this.props.colonies}
                                    required={true}
                                    onChange={this.props.onChangeColony}
                                    labelError={this.props.colonyField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_PHONE}
                                    id={INPUTS.EMPLOYMENT_PHONE}
                                    value={this.props.workplacePhoneField.value}
                                    required={true}
                                    type={InputTextTypes.NUMBER}
                                    maxLength={10}
                                    minLength={10}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.workplacePhoneField.error}
                                    onChange={this.props.onChangeWorkplacePhone}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_PHONE_EXT}
                                    id={INPUTS.EMPLOYMENT_PHONE_EXT}
                                    type={InputTextTypes.NUMBER}
                                    maxLength={10}
                                    value={this.props.workplacePhoneExtField.value}
                                    onChange={this.props.onChangeWorkplacePhoneExt}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <Options
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_TYPES}
                                    id={INPUTS.EMPLOYMENT_TYPES}
                                    name={INPUTS.EMPLOYMENT_TYPES}
                                    options={this.props.employmentTypes}
                                    onChange={this.props.onChangeEmploymentTypes}
                                    orientation={OrientationTypes.HORIZONTAL}
                                    listGroupClass="list-group-borderless"
                                    defaultValue={this.props.employmentTypesField.value.value}/>
                            </div>
                            {this.props.employmentTypesField &&
                                this.props.employmentTypesField.value.id !== CR_DEPENDENT_CATALOG_ID &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_BUSINESS_TYPE}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_BUSINESS_TYPE}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.businessTypeSelectedField.value}
                                    data={this.props.crBusinessTypeCatalog}
                                    required={true}
                                    onChange={this.props.onChangeBusinessType}
                                    labelError={this.props.businessTypeSelectedField.error}
                                    hasError={this.state.showErrors}/>
                            </div>}
                        </div>
                        <div className="row border-bottom mb-4 pb-4">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <Options
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_VALIDATE_INCOMES}
                                    id={INPUTS.EMPLOYMENT_VALIDATE_INCOMES}
                                    name={INPUTS.EMPLOYMENT_VALIDATE_INCOMES}
                                    options={this.props.booleanOptions}
                                    onChange={this.props.onChangeIncludeMonthlyIncomes}
                                    orientation={OrientationTypes.HORIZONTAL}
                                    listGroupClass="list-group-borderless"
                                    defaultValue={this.props.includeMonthlyIncomesField.value}/>
                            </div>
                            {this.props.includeMonthlyIncomesField.value &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_MONTHLY_INCOME}
                                    id={INPUTS.EMPLOYMENT_MONTHLY_INCOME}
                                    required={this.props.includeMonthlyIncomesField.value}
                                    hasError={this.state.showErrors}
                                    labelError={this.props.monthlyIncomesField.error}
                                    value={this.props.monthlyIncomesField.value}
                                    type={InputTextTypes.NUMBER}
                                    maxLength={9}
                                    minValue={0}
                                    onChange={this.props.onChangeMonthlyIncomes}/>
                            </div>}
                            {this.props.includeMonthlyIncomesField.value &&
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.EMPLOYMENT_DOCUMENT_TYPE}
                                    label={LOAN_APPLICATION_MX.EMPLOYMENT_DOCUMENT_TYPE}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.documentTypeSelectedField.value}
                                    data={this.props.crDocumentTypeCatalog}
                                    required={true}
                                    onChange={this.props.onChangeDocumentType}
                                    labelError={this.props.documentTypeSelectedField.error}
                                    hasError={this.state.showErrors}/>
                            </div>}
                        </div>

                        <div className="row mt-4 mb-3">
                            <div className="col-12 d-flex justify-content-between">
                                <Button
                                    text={LOAN_APPLICATION_MX.NEXT}
                                    onPress={this.onPressNext} role="button"
                                    customClass="ml-auto px-md-5 btn-block"/>
                            </div>
                        </div>

                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default WorkDataStepView;
